<template>
    <b-modal id="editModal" ref="modal" title="Edit ChemicalTarget" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>Chemical Target Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-link text-danger mr-auto" @click="handleDelete" v-if="!target.deleted_at">
                Disable
            </button>
            <button class="btn btn-link text-danger mr-auto" @click="handleRestore" v-if="target.deleted_at">
                Restore
            </button>
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import deleteChemicalTargetMutation from '@views/ChemicalTargets/EditModal/mutationDeleteChemicalTarget.graphql';
import restoreChemicalTargetMutation from '@views/ChemicalTargets/EditModal/mutationRestoreChemicalTarget.graphql';
import updateChemicalTargetMutation from '@views/ChemicalTargets/EditModal/mutationUpdateChemicalTarget.graphql';

export default {
  name: 'edit-modal',
  apollo: {},
  props: {
    target: {
      type: Object,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      name: this.target.name,
      show: true,
      loading: 0,
    };
  },
  computed: {
    okDisabled() {
      return this.name.length === 0;
    },
  },
  methods: {
    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        this.$apollo
          .mutate({
            mutation: updateChemicalTargetMutation,
            variables: {
              input: {
                id: this.target.id,
                name: this.name,
              },
            },
            optimisticResponse: {
              __typename: 'Mutation',
              updateChemicalTarget: {
                ...this.target,
                name: this.name,
              },
            },
          })
          .then(() => {
            this.$notifySuccess('Chemical target updated!');
            this.close();
          })
          .catch(err => {
            this.$mapGraphQLError(err);
          })
          .catch(err => {
            console.error(err);
            this.$notifyFailure(
              'Unfortunately, we were unable to do that!',
            );
          });
      });
    },
    handleDelete() {
      this.$apollo
        .mutate({
          mutation: deleteChemicalTargetMutation,
          variables: {
            input: {
              id: this.target.id,
            },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            deleteChemicalTarget: {
              ...this.target,
              deleted_at: '1970-01-01 00:00:00',
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Chemical target disabled!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    handleRestore() {
      this.$apollo
        .mutate({
          mutation: restoreChemicalTargetMutation,
          variables: {
            input: {
              id: this.target.id,
            },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            restoreChemicalTarget: {
              ...this.target,
              deleted_at: null,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Chemical target restored!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
